import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';
import JimImage from './images/jim.png';

const StyledImage = styled('img')(({ theme }) => ({
  width: '40vw',
  height: 'auto',
  borderRadius: '50%',
  position: 'absolute',
  right: '5vw',
  top: '-5%',
  outline: `2px solid ${theme.palette.error.main}`,
  outlineOffset: '1vw',
  maxWidth: '500px',

  [`@media screen and (max-width: 752px)`]: {
    width: '50vw',
  },

  [`@media screen and (min-width: ${theme.breakpoints.values.xl}px)`]: {
    right: '75px',
  },
}));

export default function AboutSection() {
  return (
    <Box id="about" sx={{ p: { lg: '0!important', xs: '0 32px' } }}>
      <Box sx={{ maxWidth: '1200px', margin: '0 auto', pt: 6, pb: 3, position: 'relative' }}>
        <StyledImage src={JimImage} alt="Dr. James D. McGlothlin" />
        <Typography
          sx={{
            fontFamily: 'ZalandoSans',
            fontWeight: '800',
            color: 'error.main',
            fontSize: '30px',
            lineHeight: 1.3,
          }}
        >
          ABOUT
        </Typography>
        <Typography
          sx={{
            mt: 2,
            mb: 3,
            fontFamily: 'ZalandoSans',
            fontWeight: '800',
            fontSize: { sm: '70px', xs: '50px' },
            width: { md: '40vw', sm: '40vw', xs: '35vw' },
            maxWidth: '420px',
            lineHeight: 1,
          }}
        >
          Dr. James D. McGlothlin,
        </Typography>
        <Typography
          sx={{
            mt: 2,
            mb: 3,
            fontFamily: 'ZalandoSans',
            fontWeight: '800',
            fontSize: '45px',
            width: { lg: '35vw', xs: '100%' },
            maxWidth: '450px',
            lineHeight: 1,
          }}
        >
          Ph.D., M.P.H., C.P.E.
        </Typography>
        <Typography
          sx={{
            fontFamily: 'ZalandoSans',
            fontWeight: '800',
            color: 'error.main',
            fontSize: '30px',
            lineHeight: 1.3,
            width: { lg: '40vw', xs: '100%' },

            maxWidth: '450px',
            mb: 3,
          }}
        >
          Innovating Workplace Health and Safety for Over 35 Years
        </Typography>
        <Box sx={{ width: { lg: '75vw', xs: '100%' }, maxWidth: '992px' }}>
          <Box sx={{ float: 'right', clear: 'right', height: '30px', width: { lg: '145px', xs: '0' } }} />
          <Box sx={{ float: 'right', clear: 'right', height: '30px', width: { lg: '120px', xs: '0' } }} />
          <Typography
            sx={{
              fontFamily: 'ZalandoSans',
              fontWeight: '600',
              fontSize: '22px',
              lineHeight: 1.5,
              mb: 5,
            }}
          >
            Dr. McGlothlin is an internationally recognized leader in ergonomics, occupational health, and exposure
            monitoring. With over four decades of experience in academia, government, and industry, he has developed
            practical, research-based solutions that improve workplace safety and performance. He is the inventor of
            Video Exposure Monitoring (VEM) technology and founder of McGlothlin Ergonomics, LLC and Video Plus Sensors,
            Inc. (VPSi).
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
